// more or less copied from src/js/shared/fathCarouselTracking.js
// fathom will eventually be phased out completely
('use strict');
import 'vendor/jquery.isOnScreen';
import Domain from 'helpers/Domain'; // ~/src/web-package-coreui/src/js/helpers/Domain.js

let track = null;

export class CarouselTracking {
    static scrollIsMonitored = false;
    static scrollInterval = null;
    static totalNumberCarousels = 1; // set counter =1 for brandCarousel
    static previouslyVisibleWrappers = new Set();

    constructor() {
        this.allWrappers = [];
        this.payload = [];
        this.metadata = {};
        this.scrollTimer = null;

        let body = document.body;
        if (body.hasAttribute('data-num-carousels')) {
            this.totalNumCarousels = parseInt(body.getAttribute('data-num-carousels'));
        }
        this.carouselCounter = 0;
    }

    static addNumCarousels(numCarousels) {
        CarouselTracking.totalNumberCarousels += numCarousels;
    }

    static removeNumCarousels(numCarousels) {
        CarouselTracking.totalNumberCarousels -= numCarousels;
    }

    addPayLoad(carousel) {
        this.payload.push(carousel);
    }

    addWrapper(wrapper) {
        this.allWrappers.push(wrapper);
    }

    buildPayObject(payObject) {
        return {
            brandPlatformId: CBS.Registry?.brandPlatformID?.toString(),
            siteEdition: CBS.Registry?.siteEdition?.toString(),
            pageType: 'front_door',
            pageViewGuid: CBS.Tracking?.utag_data?.pageViewGuid,
            searchTerm: '',
            userRegId: CBS.Registry?.user?.id?.toString() ?? '',
            userBundle: CBS.Registry?.user?.bundleStatus?.toString() ?? '',
            userStatus: CBS.Registry?.user?.sb?.toString() ?? '',
            userType: CBS.Registry?.user?.sub_status?.toString() ?? '',
            userClientRegion: CBS.Registry?.region?.property?.toString() ?? '',
            userProfileId: CBS.Registry?.user?.profile_id?.toString() ?? '',
            userProfileCategory: CBS.Registry?.user?.profile_type?.toString() ?? '',
            userProfileMaster: CBS.Registry?.user?.userProfileMaster?.toString() ?? '',
            userProfileRefId: CBS.Registry?.user?.profile_reference_id?.toString() ?? '',
            contentFeatures: payObject,
        };
    }

    enableAndResetDisplayTrackingInterval() {
        if (!CarouselTracking.scrollIsMonitored) {
            CarouselTracking.scrollIsMonitored = true; // prevents more than one scroll listener from being added
            window.addEventListener('scroll', () =>
                this.afterScrollStops(() => {
                    this.trackNewlyVisibleWrappers();
                }, 1000),
            );
        }
    }

    afterScrollStops(callback, waitTimeInMS) {
        let pageYOffset = window.pageYOffset;
        if (CarouselTracking.scrollInterval === null) {
            // prevents additional scrolling from creating additional intervals
            CarouselTracking.scrollInterval = setInterval(() => {
                if (pageYOffset === window.pageYOffset) {
                    clearInterval(CarouselTracking.scrollInterval);
                    callback();
                    CarouselTracking.scrollInterval = null;
                } else {
                    pageYOffset = window.pageYOffset;
                }
            }, waitTimeInMS);
        }
    }

    getVisibleWrappers() {
        return this.allWrappers
            .filter((element) => element.isOnScreen())
            .map((element) => this.getPayloadByDisplayID(element.data('displayid')))
            .filter((payload) => typeof payload !== 'undefined');
    }

    recordSeenWrappers(payloads) {
        payloads.forEach((x) => CarouselTracking.previouslyVisibleWrappers.add(x.position));
    }

    trackVisibleWrappers() {
        const payloads = this.getVisibleWrappers();
        this.trackWrappers(payloads);
        this.recordSeenWrappers(payloads);
    }

    trackNewlyVisibleWrappers() {
        const payloads = this.getVisibleWrappers();
        this.trackWrappers(
            payloads.filter((x) => !CarouselTracking.previouslyVisibleWrappers.has(x.position)),
        );
        this.recordSeenWrappers(payloads);
    }

    trackWrappers(payloads) {
        payloads = payloads.filter((payload) => payload.items.length > 0);
        if (payloads.length > 0)
            this.trackObject(this.buildPayObject(this.sortPayLoads(payloads)), 'carouselView');
    }

    getAllWrappers() {
        return this.allWrappers;
    }

    getPayloadByDisplayID(id) {
        return this.payload.find((obj) => obj.displayId === id);
    }

    getPayload() {
        return this.payload;
    }

    sortPayLoads(payloads) {
        return payloads.sort((a, b) => {
            return a.position - b.position;
        });
    }

    trackObject(obj, eventType) {
        if (!this.suppressTracking() && om) {
            let eventData = {
                type: eventType,
                data: {
                    pplus: this.reindexPosition(obj),
                },
            };
            om.sendEvent(eventData);
        }
    }

    deviceType() {
        if (Domain.isInternational()) return CBS.Registry.platform.current;
        if (CBS.Tracking.utag_data.deviceType == 'desktop')
            return $('body').attr('touch-enabled') == 'true' ? 'tablet_web' : 'desktop_web';
        else if (CBS.Tracking.utag_data.deviceType == 'mobile') return 'mobile_web';
        return '';
    }

    suppressTracking() {
        return (
            CBS.Registry.user.profile_type != 'ADULT' ||
            window.location.href.includes('user-profile')
        );
    }

    reindexPosition(obj) {
        if (Domain.isInternational()) return obj;
        let result = JSON.parse(JSON.stringify(obj));
        if (result?.payload)
            for (let key in result.payload)
                if (result.payload[key]?.position)
                    result.payload[key].position = result.payload[key].position - 1;
        return result;
    }
}

export default class ImpressionTracking {
    static needToDoInitialTracking = true;
    static resizeTimeout = null;

    constructor(wrapper, swiper) {
        this.wrapper = wrapper;
        this.swiper = swiper;
        this.previouslyTrackedContent = new Set();

        if (track === null) {
            track = new CarouselTracking();
            track.enableAndResetDisplayTrackingInterval();
        }

        const payload = this.buildPayLoad();
        if (!payload) {
            return;
        }
        track.addWrapper(wrapper);
        track.addPayLoad(payload);

        // Track initial carousels
        if (ImpressionTracking.needToDoInitialTracking) {
            ImpressionTracking.needToDoInitialTracking = false;
            setTimeout(() => {
                track.trackVisibleWrappers();
            }, 3000);
        }
    }

    buildPayLoad(clickedEl = null) {
        const container = this.wrapper.parents('.js-le-carousel');
        if (!container) {
            return null;
        }
        const carouselId = container.data('carouselid');
        if (!container.data('displayid') || !container.data('recoid') || !container.data('title')) {
            return null;
        }
        this.display_id = container.data('displayid')?.toString() ?? '';

        const payload = {
            position: container?.data('position') ?? '',
            containerId: carouselId ?? '',
            containerTitle: container?.data('title')?.toString() ?? '',
            containerType: container?.data('model')?.toString() ?? '',
            displayId: this.display_id,
            rowNum: container?.data('position')?.toString() ?? '',
            rankModel: container?.data('rankmodel')?.toString() ?? '',
            items: clickedEl ? this.buildClickItemContent(clickedEl) : this.buildItemContent(),
        };

        return payload;
    }

    addNewItem(content = [], dataImpression) {
        let id = dataImpression[0].toString(),
            title = dataImpression[5].toString(),
            type = dataImpression[3].toString(),
            position = parseInt(dataImpression[2]),
            badgeLabel = dataImpression[8].toString(),
            isUnlocked = !(dataImpression[9] === 'true'), // convert to boolean and use opposite value
            cmsId = dataImpression[10].toString();
        // blank isUnlocked for promo tiles
        if (type.indexOf('promo') !== -1) {
            isUnlocked = '';
        }
        content.push({
            id: dataImpression[0]?.toString(),
            title: dataImpression[5]?.toString(),
            type: dataImpression[3]?.toString(),
            position: parseInt(dataImpression[2]),
            badgeLabel: dataImpression[8]?.toString(),
            isUnlocked: !(dataImpression[9] === 'true'),
            cmsId: dataImpression[10]?.toString(),
        });
        return content;
    }

    buildClickItemContent(clickedEl = null) {
        let content = [];
        let dataImpression = $(clickedEl.currentTarget).find('a').data('impression').split('|');
        return this.addNewItem(content, dataImpression);
    }

    buildItemContent() {
        if (this.swiper.slides.length) {
            let content = [];
            for (const slide in this.swiper.slides) {
                let s = this.swiper.slides[slide];
                if (s && typeof s === 'object') {
                    let $s = $(s);
                    if ($s.hasClass('swiper-slide-visible')) {
                        let dataImpression = $s.find('a').data('impression').split('|');
                        let contentId = dataImpression[0]?.toString() ?? '';
                        if (!this.previouslyTrackedContent.has(contentId)) {
                            this.addNewItem(content, dataImpression);
                            this.previouslyTrackedContent.add(contentId);
                            this.setPayloadClick(
                                $s,
                                this.display_id,
                                contentId,
                                dataImpression[5]?.toString(),
                            );
                        }
                    }
                } else {
                    break;
                }
            }
            return content;
        }
    }

    clickEvent(event) {
        track.trackObject(
            track.buildPayObject([event.data.this.buildPayLoad(event)]),
            'carouselSelect',
        );
    }

    setPayloadClick(slide, displayId, contentId, contentTitle) {
        slide.off('click', this.clickEvent).on('click', { this: this }, this.clickEvent);
    }

    updateImpressionResizePerCarousel(position) {
        return track.getPayload().filter((x) => {
            if (parseInt(x.position) === parseInt(position)) {
                return (x.items = this.buildItemContent());
            }
        });
    }

    updateImpressionResize() {
        if (ImpressionTracking.resizeTimeout !== null)
            clearTimeout(ImpressionTracking.resizeTimeout);
        ImpressionTracking.resizeTimeout = setTimeout(() => {
            track.trackVisibleWrappers();
        }, 300);
    }

    updateImpressionTracking(position) {
        let obj = this.updateImpressionResizePerCarousel(position);
        if (obj && obj.length > 0 && obj[0].items && obj[0].items.length > 0) {
            track.trackObject(track.buildPayObject(obj), 'carouselView');
        }
    }
}
